import React, { useState, useEffect } from 'react';
import { IEditorProps } from './props-interfaces';
import { config } from 'config';
import { sendFileAsBody, SchemaSubmitForm } from '@restspace/schema-form';
import { HtmlEditor } from './html-editor';
import { quoteTrim, pathJoin } from 'utility';
import { constructPath } from 'data/metadata';
import { useHistory } from 'react-router-dom';

export const InstanceFormEditor = ({
    path, mimeType, onDirty, service, operation
}: IEditorProps) => {
    const [ value, setValue ] = useState({});
    const [ schema, setSchema ] = useState({});
    const [ formError, setFormError ] = useState('');
    const history = useHistory();

    useEffect(() => {
        if (operation === 'new') { // new item
          const schemaUrl = quoteTrim((mimeType || '').split('schema=')[1]);
          config.api.fetchSchema(schemaUrl)
            .then((schema) => {
                setSchema(schema);
                setValue({});
                setFormError('');
            })
            .catch((err) => {
                console.log('schema load failed: ' + err);
                setFormError('Schema missing: an administrator should set up a schema');
            });
        } else {
          config.api.fetchItem(path)
            .then(([ schema, value ]) => {
                setSchema(schema);
                setValue(value);
                setFormError('');
            })
            .catch((err) => {
                console.log('item load failed: ' + err);
                setFormError('Failed to load data');
            });
        }
    }, [ path, mimeType, operation ]);

    function makeSubmitLink(onClick: () => void) {
        return (
        <div className="jd-submit-button-container">
            <button type="button" className="jd-submit-button" onClick={onClick}>
            Submit
            </button>
        </div>
        );
    }

    const onDoSubmit = async (value: object) => {
        let itemPathName = ''
        try {
            itemPathName = constructPath(schema, value);
            if (!itemPathName) {
                alert('Cannot save as pathPattern generates an empty path');
                return false;
            }
        } catch (err) {
            alert('Cannot save until an admin adds pathPattern attribute to the schema');
            return false;
        }
        const itemPath = [ ...path.split('/').slice(0, -1), itemPathName ].join('/');
        const res = await config.api.saveItem(itemPath, value, mimeType);
        if (res) {
            alert('There was a problem, the changes were not saved: ' + res);
            return false;
        }
        onDirty(false);
        if (itemPath !== path) {
            history.push('/' + itemPath);
        }
        return true;
    }

    const componentContext = {
        uploadEditor: {
            getFileUrl: (file: File, filePath: string[], schema: object) => {
                if (service && service['uploadBaseUrl']) {
                    let apiUrl = config.api.apiUrl;
                    if (apiUrl.startsWith('/')) {
                        apiUrl = pathJoin(window.location.protocol + '//' +  window.location.host, apiUrl);
                    }
                    return pathJoin(apiUrl, service['uploadBaseUrl'],
                        path || '', filePath.join('/').replace(/\.json$/, ''), file.name);
                } else {
                    alert('no upload path given: nowhere to save upload');
                    return '';
                }
            },
            sendFile: (url: string, file: File, progress: (pc: number) => void) => sendFileAsBody(url, file, progress, "PUT"),
            saveSiteRelative: true
        }
    };

    if (formError) {
        return (
        <div className='form-error-container'>
            <div className='form-error'>{formError}</div>
        </div>
        );
    } else {
        return (
            <SchemaSubmitForm {...{ schema, value }}
                onDirty={onDirty}
                onSubmit={onDoSubmit}
                makeSubmitLink={makeSubmitLink}
                components={{ html: HtmlEditor }}
                componentContext={componentContext}
                collapsible={true}
            />
        );
    }
}